var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaludWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Salud_White",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.545,
    height: 47.813,
    viewBox: "0 0 56.545 47.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M2.818,101A1.1,1.1,0,1,0,3.24,99.65,1.115,1.115,0,0,0,2.818,101Z",
    transform: "translate(-2.472 -89.962)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M45.809,19.508q.164-.419.3-.834a15.81,15.81,0,0,0,.765-5.781,13.434,13.434,0,0,0-4.381-9.1A13.314,13.314,0,0,0,33.572,0a15.586,15.586,0,0,0-10,4.127.34.34,0,0,1-.45,0C21.316,2.589,17.616,0,13.168,0A13.764,13.764,0,0,0,2.948,5.179a1.106,1.106,0,0,0,1.71,1.4,11.513,11.513,0,0,1,8.511-4.372c3.743,0,6.948,2.258,8.526,3.6a2.565,2.565,0,0,0,3.347-.031,13.387,13.387,0,0,1,8.535-3.574c4.992,0,10.8,4.612,11.093,10.786a13.616,13.616,0,0,1-.66,4.983c-.123.382-.264.753-.423,1.13q-.669-.063-1.347-.064A14.346,14.346,0,0,0,27.962,33.427q0,.562.043,1.115c-1.093.891-1.98,1.62-2.722,2.248a2.981,2.981,0,0,1-3.866,0c-1-.849-2.306-1.913-3.684-3.034-4.979-4.055-11.8-9.611-13.439-12.4a15.448,15.448,0,0,1-2.029-5.226c-.035-.2-.066-.4-.1-.6a1.1,1.1,0,1,0-2.19.287c.03.234.066.471.107.7a17.559,17.559,0,0,0,2.3,5.956c1.842,3.134,8.554,8.606,13.947,13,1.37,1.117,2.665,2.173,3.651,3.007a5.183,5.183,0,0,0,6.722,0c.5-.42,1.061-.888,1.713-1.422A14.292,14.292,0,1,0,45.809,19.5ZM42.238,45.6A12.175,12.175,0,1,1,54.306,33.43,12.135,12.135,0,0,1,42.238,45.6Z",
    transform: "translate(0.031 0)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M374.135,272.1h-1.518v-1.541a2.455,2.455,0,0,0-2.446-2.458H367.52a2.455,2.455,0,0,0-2.446,2.458V272.1h-1.518a2.454,2.454,0,0,0-2.446,2.457v2.677a2.454,2.454,0,0,0,2.446,2.457h1.518v1.542a2.454,2.454,0,0,0,2.446,2.457h2.652a2.455,2.455,0,0,0,2.446-2.457v-1.543h1.518a2.454,2.454,0,0,0,2.446-2.457v-2.678A2.455,2.455,0,0,0,374.135,272.1Zm.237,5.132a.243.243,0,0,1-.237.248h-2.622a1.1,1.1,0,0,0-1.1,1.1v2.646a.243.243,0,0,1-.237.248H367.52a.243.243,0,0,1-.237-.248v-2.646a1.1,1.1,0,0,0-1.1-1.1h-2.622a.243.243,0,0,1-.237-.248v-2.677a.243.243,0,0,1,.237-.248h2.622a1.1,1.1,0,0,0,1.1-1.1v-2.643a.243.243,0,0,1,.237-.249h2.652a.243.243,0,0,1,.237.249V273.2a1.1,1.1,0,0,0,1.1,1.1h2.622a.243.243,0,0,1,.237.248Z",
    transform: "translate(-326.576 -242.463)",
    fill: "#f5f5f5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaludWhite);
export default __webpack_public_path__ + "static/media/Salud_White.41e0457075d2c005088363dc8e109061.svg";
export { ForwardRef as ReactComponent };